import { db } from "../firebase";
import { doc, onSnapshot, getDoc } from "firebase/firestore";
import { store } from "../store/store";

export default async function getDadosEmpresa(database, modo) {
  if (!modo) {
    onSnapshot(doc(db, database, "dadosempresa"), (doc) => {
      var data = Object.values(doc.data())[0];
      if (
        data.cidades.find((val) => val.id == process.env.VUE_APP_CIDADE).bairros
      ) {
        var bairros = data.cidades.find(
          (val) => val.id == process.env.VUE_APP_CIDADE,
        ).bairros;
        var cidade = data.cidades.find(
          (val) => val.id == process.env.VUE_APP_CIDADE,
        ).nome;
      }
      var metodosPgto = [];
      var dinheiro = { id: 1, nome: "Dinheiro" };
      metodosPgto.push(dinheiro);
      if (data.formasPgto) {
        data.formasPgto.forEach((val) => {
          metodosPgto.push(val);
        });
      }
      data.corBase = data.corBase ? data.corBase : "#B71C1C";
      data.sitef = data.sitef
        ? data.sitef
        : false;
      store.commit("incrementMetodosPgto", metodosPgto);
      store.commit("incrementDadosEmpresa", data);
      store.commit("incrementBairros", bairros);
      store.commit("incrementCidade", cidade);
    });
    return true;
  } else {
    const empresaData = {};

    try {
      const docRef = doc(db, database, "dadosempresa");

      await getDoc(docRef).then((doc) => {
        if (doc.exists()) {
          const data = doc.data();
      console.log(doc.data());

          empresaData[database] = data;
        } else {
          console.log("No data available");
        }
      });
    } catch (error) {
      console.log("Error getting document:", error);
    }
    return empresaData;
  }
}
